module.exports = __webpack_public_path__ + "img/icon-destination.d1d89e18.svg";